import React, { useContext, useEffect } from 'react';
import CarLoanPageContentLEFWaiver from '@/components/PersonalLoanPageContent/CarLoanPageContentLEFWaiver';
import { AnalyticsContext } from 'latitude-analytics';

const CarLoanPageLef = props => {
      const [analytics] = useContext(AnalyticsContext);
      useEffect(() => {
        const sourceCode = localStorage.getItem('source_code') || 'IDAAA';
        // adding pageData to analytics
        analytics.pageData = {
          page_pageTitle: 'car-loan-lef-waiver',
          page_pageType: 'product-details-page',
          page_siteSection: 'loans',
          page_siteSubsection: 'car-loan-lef-waiver',
          product_productid: ['PLAULF-WEB'],
          application_sourcecode: sourceCode || 'IDAAA'
        };
      }, []);
  return (
    <CarLoanPageContentLEFWaiver
      {...props}
      title="Car Loan - Establishment Fee Waiver"
      description="Car loan, you can achieve your goals with Latitude car loan. Apply for finance online today and enjoy flexible repayments. Get a quote in under 3mins."
    />
  );
};

export default CarLoanPageLef;
